import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectAuthUser, selectIsAuthenticated, selectUserRole } from '@/store/slices/auth.selectors';
import { clearCredentials } from '@/store/slices/auth.slice';

export function useAuth() {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectAuthUser);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const role = useAppSelector(selectUserRole);

  const logout = useCallback(() => {
    dispatch(clearCredentials());
  }, [dispatch]);

  return { user, isAuthenticated, role, logout };
}
